/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Eltenzeitteilzeit2Inputs */



/**

* @param {_Class_Eltenzeitteilzeit2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_eltenzeitteilzeit2 = /** @type {((inputs?: _Class_Eltenzeitteilzeit2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Eltenzeitteilzeit2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Elternzeit Teilzeit")
});
export { _class_eltenzeitteilzeit2 as "_class_EltenzeitTeilzeit" }